export default function traverseAllChildNodes(node, callback) {
  const nodeChildNodes = node.childNodes;
  callback(node);
  if (nodeChildNodes.length) {
    nodeChildNodes.forEach(childNode =>
      traverseAllChildNodes(childNode, callback),
    );
  }
}
